async function AddAction(mutationName, data) {
  try {
    await mutationName({ body: data });
  } catch (error) {
    console.log({ addError: error });
  }
}

export default AddAction;
